module.exports = __webpack_public_path__ + "static/img/image008.d2df1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image008.png
// module id = 1Z9u
// module chunks = 1